import { mainnet } from 'wagmi/chains';
import { EVMChain } from '../types';
/** wagmi/viem preset per EVMChain — add an entry when deploying to a new chain. */
export const EVM_CHAIN_REGISTRY = {
    [EVMChain.Ethereum]: mainnet,
};
/** App RPC overrides prepended before preset defaults (env + fallbacks). */
export const EVM_RPC_OVERRIDES = {
    [EVMChain.Ethereum]: [
        process.env.REACT_APP_ETH_RPC_URL,
        'https://ethereum-rpc.publicnode.com',
        'https://1rpc.io/eth',
    ].filter(Boolean),
};
export function getEvmChainPreset(chain) {
    const preset = EVM_CHAIN_REGISTRY[chain];
    if (!preset) {
        throw new Error(`Missing EVM_CHAIN_REGISTRY entry for "${chain}". Add a wagmi preset in evm-registry.ts.`);
    }
    return preset;
}
export function getEvmRpcList(chain) {
    const preset = getEvmChainPreset(chain);
    const overrides = EVM_RPC_OVERRIDES[chain] ?? [];
    return [...overrides, ...preset.rpcUrls.default.http].filter(Boolean);
}
